module.exports = __webpack_public_path__ + "img/fileIcon.5eb6f950.svg";